const array = [
  {
    path: '/events/lives/:id',
    name: 'events_lives',
    props: true,
    component: () => import('./pages/Lives.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Eventos',
      breadcrumb: [
        {
          text: 'Eventos',
          active: true,
        },
      ],
    },
  }
]

export default array
